import { render, staticRenderFns } from "./RegisterCard.vue?vue&type=template&id=5f4ffe10&scoped=true&"
import script from "./RegisterCard.vue?vue&type=script&lang=js&"
export * from "./RegisterCard.vue?vue&type=script&lang=js&"
import style0 from "./RegisterCard.vue?vue&type=style&index=0&id=5f4ffe10&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4ffe10",
  null
  
)

export default component.exports